var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-14.88 -14.88 525.92 525.92",
    xmlSpace: "preserve",
    width: "256px",
    height: "256px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#fcfcfc",
    strokeWidth: 18.853928
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF402E"
    },
    d: "M0,248.08C0,111.06,111.069,0.002,248.074,0.002c137.013,0,248.082,111.059,248.082,248.078 c0,137.005-111.069,248.074-248.082,248.074C111.069,496.154,0,385.085,0,248.08z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.768,
    y: 232.258,
    style: {
      fill: "#FFFFFF"
    },
    width: 244.62,
    height: 159.85
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.796,332.218c-7.712,0-13.964-6.252-13.964-13.964V182.269 c0-43.977-35.778-79.755-79.754-79.755s-79.754,35.778-79.754,79.755v135.984c0,7.712-6.252,13.964-13.964,13.964 s-13.964-6.252-13.964-13.964V182.269c0-59.376,48.306-107.683,107.682-107.683S355.76,122.893,355.76,182.269v135.984 C355.76,325.966,349.508,332.218,341.796,332.218z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF402E"
    },
    d: "M274.717,301.354c0-14.715-11.926-26.64-26.639-26.64c-14.712,0-26.639,11.925-26.639,26.64 c0,9.356,4.83,17.582,12.128,22.334c0,4.242,0,9.407,0,11.45c0,8.015,6.496,14.509,14.51,14.509c8.014,0,14.51-6.494,14.51-14.509 c0-2.043,0-7.207,0-11.45C269.887,318.937,274.717,310.711,274.717,301.354z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF402E"
    },
    d: "M0,248.08C0,111.06,111.069,0.002,248.074,0.002c137.013,0,248.082,111.059,248.082,248.078 c0,137.005-111.069,248.074-248.082,248.074C111.069,496.154,0,385.085,0,248.08z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.768,
    y: 232.258,
    style: {
      fill: "#FFFFFF"
    },
    width: 244.62,
    height: 159.85
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.796,332.218c-7.712,0-13.964-6.252-13.964-13.964V182.269 c0-43.977-35.778-79.755-79.754-79.755s-79.754,35.778-79.754,79.755v135.984c0,7.712-6.252,13.964-13.964,13.964 s-13.964-6.252-13.964-13.964V182.269c0-59.376,48.306-107.683,107.682-107.683S355.76,122.893,355.76,182.269v135.984 C355.76,325.966,349.508,332.218,341.796,332.218z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF402E"
    },
    d: "M274.717,301.354c0-14.715-11.926-26.64-26.639-26.64c-14.712,0-26.639,11.925-26.639,26.64 c0,9.356,4.83,17.582,12.128,22.334c0,4.242,0,9.407,0,11.45c0,8.015,6.496,14.509,14.51,14.509c8.014,0,14.51-6.494,14.51-14.509 c0-2.043,0-7.207,0-11.45C269.887,318.937,274.717,310.711,274.717,301.354z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.16d364812b1ad620c68070a05bee4705.svg";
export { ForwardRef as ReactComponent };